import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../Guides/guides.css"; 
import "./getStarted.css"; 
import { MainContent, InlineBox, ProgressBar } from "./GetStartedHelpers.jsx";
import BookmakerBanner from "../ui/BookmakerBanner.jsx";
import offersConfig from "../../config/offersConfig";
import Seo from "../Seo.jsx";
import getStartedConfig from "../../config/getStartedConfig.js";
import { OddsMonkeyFT } from "../Affiliate/Om.jsx";
import Collapsible from "../ui/Collapsible.jsx";
import faqConfig from "../../config/faqConfig"; // Import the FAQ config

const GetStarted4 = () => {
  const meta = getStartedConfig.getStarted4?.seo || {};
  const progress = getStartedConfig.progress || { currentStep: 3, totalSteps: 4 };

  const navigate = useNavigate();

  // This handler will be passed to the ProgressBar.
  const handleStepClick = (stepIndex) => {
    const targetRoute = `/get-started/step${stepIndex + 1}`;
    if (targetRoute) {
      navigate(targetRoute);
    }
  };

  // Filter FAQs for "faqs" pages and sort them descending by priority (high priority first)
  const faqsToRender = Object.keys(faqConfig)
    .map((key) => faqConfig[key])
    .filter((faq) => faq.pages.includes("faqs"))
    .sort((a, b) => b.priority - a.priority); // High priority first

  return (
    <MainContent>
      <Seo 
        title={meta.title} 
        description={meta.description} 
        url={getStartedConfig.getStarted4?.route || "/get-started/step4"}
      />

      <ProgressBar 
        currentStep={progress.currentStep} 
        totalSteps={progress.totalSteps} 
        onStepClick={handleStepClick} 
      />

      <h1>You've got the basics!</h1>
      <section>
        <h3>Let's recap.</h3>
        <h6 className="info">
          Matched betting is a way to turn free offers from betting companies into cash by placing bets that cancel each other out.
        </h6>
        <h4>1. <span className="back">Back</span> an event at the bookie to qualify.</h4>
        <h4>2. <span className="lay">Lay</span> the same event (to cancel out the bet) at an exchange.</h4>
        <h4>3. Use the <span className="key">free bet</span> to <span className="back">back</span> an event.</h4>
        <h4>4. <span className="lay">Lay</span> the same event (to cancel out the bet).</h4>
      </section>

      <section>
        <h3>What do you want to do next?</h3>
        <div className="grid-fixed g1">
          <InlineBox title="I'm ready to find an offer">
            <p>
              These bookies often run straightforward offers, which are to get you started. Always read the Ts &amp; Cs carefully.
            </p>
            {offersConfig.bookies.map((offer, index) => (
              <BookmakerBanner key={index} {...offer} />
            ))}
          </InlineBox>

          <InlineBox title="I want a tool to find matches">
            <p>
              Most matched bettors do use a tool, <strong>but you don't have to use one</strong>.
            </p>
            <p>
              They're popular because finding matches by yourself can be time-consuming and you usually miss the closest match.
            </p>
            <h6 className="info">
              We recommend OddsMonkey because it makes matched betting so fast and straightforward.
            </h6>
            <Link to="/guides/oddsmonkey-guide">
              <button className="next-button">Learn about OddsMonkey</button>
            </Link>
            <div className="oddsmonkey-banner">
              <OddsMonkeyFT />
            </div>
          </InlineBox>
        </div>
      </section>

      <section>
        {/* Render FAQs using the config */}
        <div className="collapsibles">
          {faqsToRender.map((faq, index) => (
            <Collapsible key={index} title={faq.title}>
              {faq.content}
            </Collapsible>
          ))}
        </div>
      </section>
    </MainContent>
  );
};

export default GetStarted4;
